import { Link, NavLink } from "react-router-dom";
import { ClipboardPen, FolderOpen, LayoutDashboard, SearchCheck } from "lucide-react";
import { BrandMark } from "@/components/BrandMark";
import { UserMenu } from "@/components/UserMenu";
import { useAuth } from "@/context/AuthContext";
import { cn } from "@/lib/utils";

const NAV = [
  { to: "/", label: "Form Pengaduan", icon: ClipboardPen, testId: "nav-form-link", end: true },
  { to: "/lacak", label: "Lacak Tiket", icon: SearchCheck, testId: "nav-track-link" },
  { to: "/pengaduan-saya", label: "Pengaduan Saya", icon: FolderOpen, testId: "nav-my-link", show: (u) => u?.role === "warga" },
  { to: "/admin", label: "Dashboard Admin RT", icon: LayoutDashboard, testId: "nav-admin-link", show: (u) => u?.role !== "warga" },
];

export const AppHeader = () => {
  const { user } = useAuth();
  const items = NAV.filter((n) => !n.show || n.show(user));
  return (
  <header className="sticky top-0 z-40 border-b border-white/5 bg-slate-900/95 backdrop-blur-xl" data-testid="app-header">
    <div className="mx-auto flex max-w-7xl items-center gap-3 px-4 pt-3 sm:px-6 lg:px-8">
      <Link to="/" className="flex min-w-0 flex-1 items-center gap-3 py-2" data-testid="header-home-link">
        <BrandMark />
        <h1 className="font-heading text-[13px] font-bold leading-snug text-white sm:text-base" data-testid="header-title">
          Sistem Pelaporan &amp; Pengaduan Warga - Vila Nusa Indah 5 Cluster Merak
        </h1>
      </Link>
      <div className="shrink-0">
        <UserMenu />
      </div>
    </div>
    <nav className="mx-auto flex max-w-7xl gap-1 overflow-x-auto px-4 pb-2.5 pt-3 sm:px-6 lg:px-8" aria-label="Navigasi utama">
      {items.map(({ to, label, icon: Icon, testId, end }) => (
        <NavLink
          key={to}
          to={to}
          end={end}
          data-testid={testId}
          className={({ isActive }) =>
            cn(
              "inline-flex shrink-0 items-center gap-1.5 rounded-full px-3 py-1.5 text-[13px] font-medium transition-colors duration-200 sm:gap-2 sm:px-4 sm:text-sm",
              isActive ? "bg-white text-slate-900" : "text-slate-300 hover:bg-white/10 hover:text-white",
            )
          }
        >
          <Icon className="h-4 w-4" />
          {label}
        </NavLink>
      ))}
    </nav>
  </header>
  );
};
